define('helperLayout-nodeStyle',[],function() {
    'use strict';

    var nodeStyle = function(node, prop) {
        if (node.style[prop]) {
            return node.style[prop];
        } else if (node.currentStyle) {
            return node.currentStyle[prop];
        }
        else if (document.defaultView && document.defaultView.getComputedStyle) {
            prop = prop.replace(/([A-Z])/g, '-$1');
            prop = prop.toLowerCase();
            var s = document.defaultView.getComputedStyle(node, '');
            return s && s.getPropertyValue(prop);
        } else {
            return null;
        }
    };

    return nodeStyle;
});

